import { SceneState } from '../../components/SceneStatemachinePlugin';
import { ActionsPlayer } from 'game/components/ActionsPlayer.js';

// =============================================================================================
// STATE : INTRO
// =============================================================================================
export class StateScenarioIntro extends SceneState {
  constructor(scene, scenario) {
    super(scene);
    this._scenario = scenario;
  }

  startState() {
    this.scene.playScenarioMusic();
    const { configId } = this._scenario.intro;
    const sceneCharacters = this._scenario.scene_objects
      .filter((o) => o.type === 'character')
      .map((c) => {
        return this.scene.getSceneObject(c.id, c.type);
      });

    this._config = this.game.cache.json.get(configId);
    const opts = { game: this.game, scene: this.scene, x: 0, y: 0, config: this._config };
    this._actionsPlayer = new ActionsPlayer(opts);
    this._actionsPlayer.addSceneCharacters(sceneCharacters);
    this._actionsPlayer.once('COMPLETE_ACTIONS', () => {
      this.emit('state_complete');
    });
    this._actionsPlayer.start();
  }

  onScenePaused() {}
  onSceneResumed() {}
  onSceneUpdate(time, delta) {}
  endState() {
    if (this._actionsPlayer) {
      this._actionsPlayer.destroy();
      this._actionsPlayer = null;
    }
    if (this._textBox) {
      this._textBox.destroy();
      this._textBox = null;
    }
    if (this._timer) {
      this._timer.destroy();
      this._timer = null;
    }
  }
}
